// Blog posts for bloxsocial.live/blogs. Newest first.
//
// Each post is a list of blocks:
//   { p: "text" }                     paragraph
//   { h: "text" }                     section heading
//   { list: ["…", "…"] }              bullet list
//   { quote: "text" }                 pull quote
//   { tip: "text", title?: "…" }      highlighted callout

const posts = [
  {
    slug: "new-on-blox-going-out-features",
    title: "New on Blox: meet your group, double up, and leave an echo",
    excerpt: "Small groups before every event, crew matching, voice notes pinned to places, seat swaps and more. Everything new that gets you out of the house.",
    category: "Inside Blox",
    emoji: "✨",
    accent: "#ffe600",
    date: "2026-11-04",
    readMins: 3,
    blocks: [
      { p: "Blox has always been about meeting people in real life. This update is about the hardest parts of that: walking into a room where you know nobody, finding someone to go with, and staying in touch after." },
      { h: "Meet your group before you go" },
      { p: "A day before every event, we put everyone with a confirmed pass into a small group of 3–5 guests with its own chat. Say hi, agree to meet at the entrance, and walk in knowing a few faces. Not your thing? Leave the group with one tap." },
      { h: "I'm free now" },
      { p: "Free for the next couple of hours? Tap \"I'm free\" on the Plans map, pick a vibe (chill, food, drinks, active) and your squad sees it. If a friend is free too, you'll both get a nudge, and one tap turns it into a plan." },
      { h: "Double up" },
      { p: "Going out with friends? Make a crew of 2–4 and match with another crew nearby. Both crews have to like each other, and then you get one group chat. It's a group hangout, so it's easier and safer than meeting one-on-one." },
      { h: "Echoes: voice notes left at places" },
      { p: "Know the best chai stall behind the metro gate? Record a 30-second echo and pin it there. Anyone can see the pin on the map, but it only plays for people who are actually standing nearby." },
      { h: "And a few more" },
      { list: [
        "See which friends are going to an event or plan before you decide.",
        "Can't make it? Pass your seat to a friend, or give it back to the waitlist, instead of letting it go empty.",
        "Full plans now have a waitlist: if someone drops out, the next person is in automatically.",
        "Check in with \"I'm here\" when you arrive at a plan, so everyone knows who's there.",
        "Split costs for dinner, cabs and tickets, and see who owes whom.",
        "After a plan or event, add the people you met to your squad in one tap.",
      ] },
      { tip: "Update Blox from the App Store or Google Play to get all of this.", title: "Get the update" },
    ],
  },
  {
    slug: "boos-and-brews-halloween-cafe-leaf-n-latte-lucknow",
    title: "Boos and Brews: a haunted garden night at Cafe Leaf N Latte",
    excerpt: "Halloween comes to Gomti Nagar. Free coffee, a costume contest and fifty students meeting outside the classroom, two nights only.",
    category: "Events & Go Out",
    emoji: "🎃",
    accent: "#ff8a3d",
    date: "2026-10-16",
    readMins: 3,
    blocks: [
      { p: "This Halloween, Cafe Leaf N Latte in Gomti Nagar turns into a haunted garden, and Amity Lucknow students are invited. No boring introductions and no awkward small talk: just coffee, costumes, games, music and people from different courses meeting outside the classroom." },
      { h: "Two nights, two passes" },
      { list: [
        "Halloween Night: Saturday, 31 October, from 5:30 PM.",
        "Halloween Encore: Sunday, 1 November, for anyone who can't make the first night.",
        "Each pass works only on its own night, and there are 50 spots per night.",
      ] },
      { h: "What's waiting for you" },
      { list: [
        "Free coffee for everyone with a pass",
        "A costume contest: come as a vampire, witch, ghost or anything you can call a costume",
        "A haunted photo corner",
        "Halloween games and ice-breakers, so nobody stands alone in a corner",
        "Fairy lights, pumpkins and a café dressed for the night",
      ] },
      { h: "Pick your drink when you book" },
      { p: "When you book, we'll ask what you'd like to drink. Your answer goes straight to the café, so your coffee is ready when you arrive. You can change your pick until bookings close." },
      { quote: "Come for the coffee, stay for the costumes, leave with a few new friends." },
      { h: "Where and when to book" },
      { list: [
        "Venue: Cafe Leaf N Latte, Kisan Bazar, Gomti Nagar, Lucknow",
        "Bookings close on Tuesday, 27 October, or earlier if the spots run out.",
        "Book in the Blox app or on the event page at bloxsocial.live, then show your pass at the door.",
      ] },
      { tip: "Open the Events tab in the Blox app and look for Boos and Brews, or ask a friend to share the event link with you.", title: "Grab your spot" },
    ],
  },
  {
    slug: "pay-for-blox-events-with-upi",
    title: "Paying for Blox events with UPI: scan, pay, done",
    excerpt: "Book a pass on the website and pay with GPay, PhonePe, Paytm or any UPI app. Here's what happens after you pay.",
    category: "Events & Go Out",
    emoji: "📲",
    accent: "#2bc46b",
    date: "2026-10-15",
    readMins: 3,
    blocks: [
      { p: "Most students pay for everything with UPI, so that's how you can pay for event passes on the Blox website too. No card needed, no app to install first." },
      { h: "How it works" },
      { list: [
        "Choose your pass on the event page and answer any booking questions.",
        "Tap Pay with UPI. You'll see a QR code with the exact amount already filled in.",
        "Scan it with any UPI app. On your phone, tap Pay with UPI app to open it directly.",
        "Once you've paid, tap \"Yes, I've paid\" and confirm.",
      ] },
      { h: "What \"Payment pending\" means" },
      { p: "Your spot is reserved the moment you confirm. Your ticket shows Payment pending while our team matches your payment, and it switches to confirmed as soon as that's done, usually well before the event." },
      { p: "If you have your UPI transaction ID (UTR) handy, add it when you confirm. It's in your UPI app's payment details, and it helps us find your payment faster." },
      { h: "What you'll pay" },
      { p: "The amount on the QR is the pass price plus a 3% platform fee, exact to the paisa. The summary shows the breakdown before you pay, so there are no surprises." },
      { quote: "Scan, pay, confirm. Your spot is held while we check." },
      { h: "Haven't paid yet?" },
      { p: "Tap \"Not yet\" and take your time. Your spot is only reserved after you confirm, so don't confirm until the payment has gone through." },
      { tip: "Something not right with your payment? Use Contact support on your ticket and we'll sort it out.", title: "Need help?" },
    ],
  },
  {
    slug: "day-passes-booking-questions-qr-check-in",
    title: "Booking Blox events: day passes, quick questions and QR check-in",
    excerpt: "Pick the night you're coming, tell us your drink, and walk in with a QR pass. Here's how booking works now.",
    category: "Events & Go Out",
    emoji: "🎫",
    accent: "#9b6bff",
    date: "2026-10-15",
    readMins: 4,
    blocks: [
      { p: "Some events run over more than one day, and organisers need to know a few things before you arrive. We've rebuilt booking on Blox around both." },
      { h: "Day passes" },
      { p: "Multi-day events now have a pass for each day, each with its own date, colour and number of spots. Pick the day you're coming. Your pass works only on that day, which keeps every night properly planned and never overbooked." },
      { list: [
        "One pass per person, per event.",
        "Spots left are shown on each pass, so you know when it's filling up.",
        "Sold-out days are clearly marked.",
      ] },
      { h: "A few quick questions" },
      { p: "Organisers can ask short questions when you book: which drink you'd like, whether you're coming in costume, whether you want a ride from the gate, or anything else that helps them plan. Most take a tap to answer." },
      { p: "Changed your mind? You can update your answers until bookings close." },
      { h: "Walk in with a QR pass" },
      { p: "Once your pass is confirmed, open it in the Blox app and you'll find a QR code. Show it at the door and the organiser scans it to check you in. The colour and day on your pass make it easy to see you're at the right night." },
      { quote: "Book the day, answer a question or two, show your QR. That's it." },
      { h: "For organisers" },
      { list: [
        "Set up a pass for each day, with its own price, colour and capacity.",
        "Add booking questions and see the answers counted up per pass, e.g. how many lattes to prepare.",
        "Scan passes at the door, with a warning if someone's on the wrong day.",
      ] },
      { tip: "Running an event and want to use day passes or booking questions? Reach out to us at support@bloxsocial.co.", title: "For organisers" },
    ],
  },
  {
    slug: "blox-in-one-place-communities-plans-set-me-up-go-out",
    title: "Blox, explained: communities, plans, Set Me Up and Go Out",
    excerpt: "One app for your campus life. Here's how the pieces fit together, from your college community to a night out with five new people.",
    category: "Inside Blox",
    emoji: "🧭",
    accent: "#171717",
    date: "2026-10-14",
    readMins: 5,
    blocks: [
      { p: "Most apps solve one slice of student life. A group chat for your class, a separate app for events, another for meeting people, and a dozen screenshots of plans that never happen. Blox puts those moments in one place, built around the people who are actually near you." },
      { p: "Here's a quick tour of how it all fits together." },
      { h: "1. Communities: where you belong" },
      { p: "Every college on Blox has a private community that only verified students can post in. It's your campus noticeboard, your batch's group chat and your society's announcement board, without the noise from people who don't go there." },
      { p: "Next to those are public communities, built around interests rather than institutions: football, film, startups, anime, fitness. Anyone can join, which makes them the best way to find your people beyond your campus." },
      { h: "2. Plans: say it out loud, on a map" },
      { p: "Want to grab dinner, catch a match or go for a sunrise trek? Drop a plan on the map with a place and a time. People nearby can see it and ask to join. No more waiting for someone else to make the first move." },
      { h: "3. Set Me Up: dating, only if you want it" },
      { p: "Blox isn't a dating app, and it never assumes you're looking. If you are, you can switch on dating mode and Set Me Up will introduce you to people who've done the same. Switch it off and it disappears." },
      { h: "4. Events and Go Out: get off your phone" },
      { p: "The Events tab lists what's happening around you, from campus fests to nights hosted by the Blox team and organisers in your city. Go Out is something different: small, ticketed outings of six (three women and three men) planned for you, so all you have to do is show up." },
      { quote: "Communities help you find your people. Plans, events and Go Out get you in the same room as them." },
      { h: "Where to start" },
      { list: [
        "Join your college community and verify your student ID.",
        "Follow two or three public communities for things you genuinely care about.",
        "Make one plan this week, even if it's just coffee.",
      ] },
      { tip: "Download Blox on the App Store or Google Play and sign up with your email. It takes about two minutes.", title: "Get started" },
    ],
  },
  {
    slug: "go-out-three-and-three-new-way-to-meet",
    title: "Go Out: three and three, a better way to meet people in real life",
    excerpt: "Six people, one table, zero awkward planning. Here's why small, balanced outings beat endless swiping.",
    category: "Events & Go Out",
    emoji: "🥂",
    accent: "#ff5e8e",
    date: "2026-10-11",
    readMins: 5,
    blocks: [
      { p: "Ask anyone how they met their closest friends and you'll rarely hear \"we matched on an app.\" You'll hear about a class, a trip, a friend's birthday dinner: a room with a few people, a shared plan and enough time to actually talk." },
      { p: "Go Out is built to recreate that on purpose." },
      { h: "How it works" },
      { list: [
        "Each outing is six people: three women and three men.",
        "Everyone books and pays for their own spot in the app, so the plan is real and the table is full.",
        "We pick the place, time and format, from dinners and café crawls to bowling and live music.",
        "You find out who's coming as the group fills up, and you meet at the venue.",
      ] },
      { h: "Why six people?" },
      { p: "Two strangers on a date feel like an interview. A party of fifty is too loud to meet anyone properly. Six is the sweet spot: small enough that everyone talks to everyone, big enough that there's never a lull and no one feels on the spot." },
      { p: "Keeping the group balanced means nobody is the odd one out, and it makes the evening feel social rather than staged." },
      { h: "Why it's paid" },
      { p: "Free plans are easy to bail on. When everyone has booked a seat, people show up. Your booking also covers the arrangements, so the venue is set before you arrive." },
      { quote: "The hardest part of meeting new people is organising it. Go Out does that bit for you." },
      { h: "Is it a date?" },
      { p: "It can be, but it doesn't have to be. Some people come to make friends in a new city, some to widen their circle beyond their course, and some hope to meet someone special. The format works for all three, because the focus is on a good evening, not a verdict." },
      { h: "Staying safe" },
      { list: [
        "Everyone on an outing has a Blox account linked to a real email.",
        "Venues are public places chosen by the Blox team.",
        "You can report anyone directly from the app, during or after the outing.",
      ] },
      { tip: "Open the Events tab in the Blox app and switch to Go Out to see outings near you.", title: "Find a Go Out" },
    ],
  },
  {
    slug: "events-on-blox-campus-fests-to-blox-nights",
    title: "Events on Blox: from campus fests to Blox nights",
    excerpt: "Every event worth knowing about in one tab: what's on, who's going, and a ticket in two taps.",
    category: "Events & Go Out",
    emoji: "🎟️",
    accent: "#ff7a2f",
    date: "2026-10-08",
    readMins: 4,
    blocks: [
      { p: "Campus life has no shortage of things to do. The problem is finding out about them in time. Posters go up a day late, the society Instagram posts the night before, and the best events get passed around in group chats you aren't in." },
      { p: "The Events tab on Blox fixes that." },
      { h: "What you'll find" },
      { list: [
        "Events hosted by the Blox team: mixers, themed nights, workshops and meetups.",
        "Events from clubs, societies and organisers in your city.",
        "Campus events from your college community.",
      ] },
      { h: "RSVP in two taps" },
      { p: "Each event page has the date, venue, ticket tiers and how many spots are left. Pick a ticket, confirm, and it's saved in the app. Free events are one tap; paid ones go through a secure checkout." },
      { p: "On the day, open your ticket and show it at the door, where the organiser checks you in." },
      { h: "See who's going" },
      { p: "Events are more fun when you know someone there. Blox shows how many people are interested and registered, and the comments on each event are a good place to find someone to go with." },
      { h: "Hosting your own" },
      { p: "If you run a club, society or community, you can work with the Blox team to list your events, sell tickets and manage check-in from one dashboard." },
      { tip: "Got an event you'd like on Blox? Reach out to us at support@bloxsocial.co.", title: "For organisers" },
    ],
  },
  {
    slug: "set-me-up-safety-consent-and-control",
    title: "Set Me Up: why dating on Blox is opt-in, and how we keep it safe",
    excerpt: "Dating mode is off by default. Here's what changes when you turn it on, and the controls that stay in your hands.",
    category: "Set Me Up",
    emoji: "🛡️",
    accent: "#9b5de5",
    date: "2026-10-05",
    readMins: 4,
    blocks: [
      { p: "We built Blox for friendship and community first. That's why Set Me Up, our dating feature, stays completely out of the way unless you choose to turn it on." },
      { h: "Off unless you say so" },
      { p: "When you sign up, dating mode is off. Nobody can see you in Set Me Up, and you won't see anyone there. Your profile, communities and plans work exactly the same either way." },
      { h: "What changes when you turn it on" },
      { list: [
        "You appear only to other people who've also switched dating mode on.",
        "You choose who you'd like to be introduced to.",
        "Conversations only open when both people are interested.",
      ] },
      { h: "You stay in control" },
      { list: [
        "Switch dating mode off at any time and you disappear from Set Me Up straight away.",
        "Block or report anyone from their profile or your chat.",
        "Your dating preferences are never shown on your public profile.",
      ] },
      { quote: "Opting in should be a choice you make, not a setting you have to find and turn off." },
      { h: "Meeting in person" },
      { p: "If you decide to meet, choose a public place, tell a friend where you're going and keep your first meet-up short. A coffee or a walk is plenty." },
      { tip: "If someone makes you uncomfortable, report them in the app. Our team reviews every report.", title: "Something feels off?" },
    ],
  },
  {
    slug: "set-me-up-dating-mode-campus",
    title: "Set Me Up: meet someone through the people around you",
    excerpt: "Switch on dating mode and let Blox introduce you to people from your campus and communities. No endless swiping required.",
    category: "Set Me Up",
    emoji: "💛",
    accent: "#ff5e8e",
    date: "2026-10-02",
    readMins: 4,
    blocks: [
      { p: "The best introductions have always come from people who know you. A friend who says \"you two would get along\" beats a thousand anonymous profiles." },
      { p: "Set Me Up brings that feeling to Blox." },
      { h: "Start by switching on dating mode" },
      { p: "Set Me Up only works for people who choose it. Turn on dating mode in your settings and you'll see others who have done the same. Everyone else on Blox carries on as normal and never sees you there." },
      { h: "Introductions, not a feed" },
      { p: "Instead of an endless stack of faces, Set Me Up suggests people you have something in common with: your campus, the communities you're part of, the interests you picked when you joined." },
      { p: "When you're both interested, a chat opens. If you're not, nothing happens and nobody is told." },
      { h: "Why campus first?" },
      { list: [
        "You already share places, people and plans, so conversations start easily.",
        "Your college community adds trust, because you're dealing with real students.",
        "Meeting up is simple when you're a short walk apart.",
      ] },
      { quote: "Less swiping, more \"wait, you were at that event too?\"" },
      { h: "Try it your way" },
      { p: "Some people switch on dating mode for a week, some leave it on, and some never touch it. All of those are fine. Blox works just as well either way." },
      { tip: "Open your profile settings in the Blox app and look for dating mode.", title: "Turn on Set Me Up" },
    ],
  },
  {
    slug: "hosting-a-plan-tips",
    title: "How to host a plan people actually show up to",
    excerpt: "Clear time, public place, small group. Six simple habits that turn \"we should hang out\" into a plan that happens.",
    category: "Plans",
    emoji: "📍",
    accent: "#00a99d",
    date: "2026-09-29",
    readMins: 4,
    blocks: [
      { p: "Putting a plan on the map takes ten seconds. Making it one people want to join takes a little thought. Here's what works." },
      { h: "1. Be specific" },
      { p: "\"Chill sometime this week?\" gets nothing. \"Momos at the food court, Thursday 7pm\" gets people. A clear place and time make it easy to say yes." },
      { h: "2. Pick a public place" },
      { p: "Cafés, campus spots, parks and venues are best, especially for a first plan with people you haven't met. It makes everyone more comfortable, you included." },
      { h: "3. Keep it small" },
      { p: "Set a sensible limit on how many people can join. Four to eight is great for most plans: enough energy, still easy to talk." },
      { h: "4. Say what to expect" },
      { list: [
        "Is it free, or split the bill?",
        "Do people need to bring anything?",
        "Is it beginner-friendly? (Especially for sport or treks.)",
      ] },
      { h: "5. Reply to requests quickly" },
      { p: "People are more likely to come if they hear back fast. Approve requests, answer questions in the plan chat and share any changes early." },
      { h: "6. Show up first" },
      { p: "Arrive a few minutes early so the first person to turn up isn't standing around alone. It sets the tone for everyone." },
      { tip: "After the plan, follow the people you met. The next plan gets easier every time.", title: "Bonus" },
    ],
  },
  {
    slug: "plans-on-the-map-make-a-plan-others-join",
    title: "Plans: put your plan on the map and let people join you",
    excerpt: "Going for dinner, a match or a sunrise trek? Drop it on the map. People nearby can ask to tag along.",
    category: "Plans",
    emoji: "🗺️",
    accent: "#3a86ff",
    date: "2026-09-26",
    readMins: 4,
    blocks: [
      { p: "You've probably had this moment: you're heading somewhere fun, and you think \"someone else would love this too.\" Plans on Blox turn that thought into an invitation." },
      { h: "How Plans work" },
      { list: [
        "Create a plan with what you're doing, where and when.",
        "It shows up as a pin on the Blox map for people nearby.",
        "Others tap the pin, see the details and ask to join.",
        "You decide who comes, and a group chat keeps everyone in the loop.",
      ] },
      { h: "What people use it for" },
      { list: [
        "Dinner at that place everyone keeps talking about",
        "Watching the big match together",
        "Weekend treks, cycling and runs",
        "Study sessions before exams",
        "Exploring a new city when you've just moved",
      ] },
      { quote: "The map turns \"is anyone free?\" into \"look who's already going.\"" },
      { h: "Join someone else's plan" },
      { p: "Not in the mood to host? Open the map and browse what's happening around you. It's the easiest way to try something new without organising anything." },
      { h: "Stay safe" },
      { p: "Plans are best in public places. You can see who's joining before you go, and you can leave a plan or report someone at any time." },
      { tip: "Open the map in the Blox app and tap + to drop your first plan.", title: "Make a plan" },
    ],
  },
  {
    slug: "private-vs-public-communities-which-to-join",
    title: "Private or public: which Blox communities should you join?",
    excerpt: "Your college community keeps you in the loop. Public communities help you find your people. Here's how to use both.",
    category: "Communities",
    emoji: "🧩",
    accent: "#6a5ae0",
    date: "2026-09-23",
    readMins: 3,
    blocks: [
      { p: "Blox has two kinds of communities, and they do different jobs. Here's a simple way to think about them." },
      { h: "Private: your college" },
      { list: [
        "One per college, created for every campus on Blox.",
        "Anyone from the college can join; verified students can post.",
        "Best for: announcements, campus events, lost-and-found, batch updates, notes and yearbooks.",
      ] },
      { h: "Public: your interests" },
      { list: [
        "Built around a topic, like football, filmmaking, startups or K-pop.",
        "Open to everyone, from any college or city.",
        "Best for: finding people who share your passion, swapping recommendations and making plans around it.",
      ] },
      { h: "A good starting mix" },
      { p: "Join your college community first. Then add two or three public communities you'd genuinely check every week. Fewer, more active communities beat a long list you never open." },
      { quote: "Private keeps you connected to your campus. Public connects you to everyone else who loves what you love." },
      { tip: "Head to the Orbit tab in the Blox app to browse communities.", title: "Explore communities" },
    ],
  },
  {
    slug: "public-communities-find-your-people",
    title: "Public communities: find your people beyond your campus",
    excerpt: "Your interests don't stop at your college gate. Public communities connect you with people who love the same things, wherever they study.",
    category: "Communities",
    emoji: "🌍",
    accent: "#2bc46b",
    date: "2026-09-20",
    readMins: 4,
    blocks: [
      { p: "Your course decides who you sit next to. It doesn't decide who you'll click with. Maybe you're the only person in your class who's into photography, or you want a five-a-side team that actually turns up." },
      { p: "That's what public communities are for." },
      { h: "What makes them different" },
      { list: [
        "Built around an interest, not an institution.",
        "Open to anyone on Blox, from any campus or city.",
        "A mix of discussion, recommendations and real-world plans.",
      ] },
      { h: "Popular kinds of communities" },
      { list: [
        "Sport and fitness: football, badminton, running, gym",
        "Creative: photography, music, design, writing",
        "Career: startups, product, finance, coding",
        "Fun: gaming, anime, films, food",
      ] },
      { h: "From posts to plans" },
      { p: "The best communities don't stay online. Someone posts about a match screening, a few people say they're in, and it becomes a plan on the map. That's when online friends become real ones." },
      { quote: "Find the people first. The plans follow." },
      { h: "Being a good member" },
      { list: [
        "Introduce yourself when you join.",
        "Share things you'd want to see yourself.",
        "Keep it kind: you're talking to real people.",
      ] },
      { tip: "Open the Orbit tab in the Blox app to discover public communities.", title: "Find your community" },
    ],
  },
  {
    slug: "private-college-communities-your-campus-one-place",
    title: "Your campus, in one place: private college communities on Blox",
    excerpt: "Every college on Blox has its own private community: a trusted space for campus news, events and your batch, without the noise.",
    category: "Communities",
    emoji: "🎓",
    accent: "#ffbf00",
    date: "2026-09-17",
    readMins: 4,
    blocks: [
      { p: "Campus information is scattered everywhere. Fest announcements in one group, assignment updates in another, a lost ID card posted on a story that disappears in a day. You end up missing half of it." },
      { p: "Private college communities bring it together." },
      { h: "One community for every college" },
      { p: "Every college on Blox gets its own private community. When you sign up and add your college, you'll find it waiting." },
      { h: "Why verified students can post" },
      { p: "Anyone from your college can join, but only students who've verified their college can post and chat. That keeps it trustworthy: the people talking are people who actually go there." },
      { p: "Verifying is quick. Upload your student ID from your profile, and once it's approved, you're in." },
      { h: "What it's great for" },
      { list: [
        "Campus announcements and fest updates",
        "Events organised by clubs and societies",
        "Your batch's conversations in one channel",
        "Notes, resources and yearbook memories",
        "Lost and found, roommate searches and quick questions",
      ] },
      { quote: "It's the noticeboard, the group chat and the yearbook, all in one trusted space." },
      { h: "Your college, your rules" },
      { p: "Keep it helpful and kind. Communities thrive when people share useful things and look out for each other." },
      { tip: "Open your college community in the Blox app and verify your student ID to start posting.", title: "Find your campus" },
    ],
  },
];

export default posts;

export const categories = ["All", ...Array.from(new Set(posts.map((p) => p.category)))];

export const findPost = (slug) => posts.find((p) => p.slug === slug);
